import React from 'react';
import {
  Modal as ModalBootstrap,
  ModalProps as ModalBootstrapProps,
} from 'react-bootstrap';
import './style.css';

interface CustomModalProps extends ModalBootstrapProps {
  icone?: string;
  tituloModal?: string;
  open: boolean;
  onHide: () => void;
  children: React.ReactNode;
  modalSize?: string;
  clear?: boolean;
  style?: React.CSSProperties;
  modalHeight?: string | number;
}

function Modal({
  icone,
  tituloModal,
  open,
  onHide,
  children,
  modalSize,
  clear,
  style,
  modalHeight,
  ...props
}: CustomModalProps) {
  if (!clear) {
    if (modalSize === 'medio') {
      return (
        <>
          <ModalBootstrap
            show={open}
            onHide={onHide}
            aria-labelledby="informes-modal"
            centered
            style={style}
            {...props}
          >
            <ModalBootstrap.Header closeButton>
              <ModalBootstrap.Title
                id="informes-modal"
                className="d-flex align-items-center fw-normal"
              >
                <span className="material-icons" style={{ color: '#0a58ca' }}>
                  {icone}
                </span>
                &nbsp;{tituloModal}
              </ModalBootstrap.Title>
            </ModalBootstrap.Header>
            <ModalBootstrap.Body
              style={{
                padding: '30px',
                ...(modalHeight
                  ? { height: modalHeight, overflowY: 'auto' }
                  : {}),
              }}
            >
              {children}
            </ModalBootstrap.Body>
          </ModalBootstrap>
        </>
      );
    }
    return (
      <>
        <ModalBootstrap
          show={open}
          onHide={onHide}
          dialogClassName="custom-modal"
          aria-labelledby="informes-modal"
          centered
          style={style}
          {...props}
        >
          <ModalBootstrap.Header closeButton>
            <ModalBootstrap.Title
              id="informes-modal"
              className="d-flex align-items-center fw-normal"
            >
              <span className="material-icons" style={{ color: '#0a58ca' }}>
                {icone}
              </span>
              &nbsp;{tituloModal}
            </ModalBootstrap.Title>
          </ModalBootstrap.Header>
          <ModalBootstrap.Body
            style={{
              padding: '30px',
              ...(modalHeight
                ? { height: modalHeight, overflowY: 'auto' }
                : {}),
            }}
          >
            {children}
          </ModalBootstrap.Body>
        </ModalBootstrap>
      </>
    );
  } else {
    if (modalSize === 'medio') {
      return (
        <>
          <ModalBootstrap
            show={open}
            onHide={onHide}
            aria-labelledby="clear-modal"
            centered
            style={style}
            {...props}
          >
            <ModalBootstrap.Body
              style={{
                padding: '30px',
                ...(modalHeight
                  ? { height: modalHeight, overflowY: 'auto' }
                  : {}),
              }}
            >
              {children}
            </ModalBootstrap.Body>
          </ModalBootstrap>
        </>
      );
    }
    return (
      <>
        <ModalBootstrap
          show={open}
          onHide={onHide}
          dialogClassName="custom-modal"
          aria-labelledby="clear-modal"
          centered
          style={style}
          {...props}
        >
          <ModalBootstrap.Body
            style={{
              padding: '30px',
              ...(modalHeight
                ? { height: modalHeight, overflowY: 'auto' }
                : {}),
            }}
          >
            {children}
          </ModalBootstrap.Body>
        </ModalBootstrap>
      </>
    );
  }
}
export default Modal;
